// RecivedOffersCar.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_DOMAIN } from "config";
import "../../styles/offers.css";

import { Button, Heading, Img } from "../../components";
import AllOffersProviderLinesRowSeven from "../../components/AllOffersProviderLinesRowSeven";
import ApprovedOffersProvider from "../../components/ApprovedOffersProvider";
import ApproveOfferByProviderPopup from "components/ApproveOfferByProviderPopup";

export default function RecivedOffersCar({ currentUser }) {
  const navigate = useNavigate();
  const { id } = useParams(); // carId
  const [sp] = useSearchParams();

  const status = Number(sp.get("status") ?? 1); // 1=חדשות, 2=אושרו(+נדחו)
  const carId = Number(id);

  const [loading, setLoading] = useState(true);
  const [group, setGroup] = useState(null); // { car, offers }

  // ✅ פופאפ כמו בעמוד הראשי
  const [showApprovedOfferPopuop, setShowApprovedOfferPopuop] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);
  const [selectedOffer, setSelectedOffer] = useState(null);

  const handlePopupClose = () => setShowApprovedOfferPopuop(false);
  const UpdateShowApprovedOfferPopup = (state) => setShowApprovedOfferPopuop(!!state);

  useEffect(() => {
    if (!currentUser?.id || !carId) return;

    let cancelled = false;

    const mapGroup = (rawGroup) => ({
      car: {
        ...rawGroup.car,
        images: (rawGroup.images || []).map((u) => ({ image_url: u })),
      },
      offers: (rawGroup.offers || []).map((o) => ({
        id: o.id,
        buyerName: o.buyer_name || "",
        buyerContactName: o.buyer_contact_name,
        buyerPhoneNumber: o.buyer_phone_number,
        buyerId: o.user_id,
        offerDate: o.creation_date,
        offerPosition: o.offer_position,
        collectionDate: o.collection_date,
        lastPaymentDate: o.last_payment_date,
        price: o.offered_price,
        isReserved: o.is_reserved === 1,
        status: o.status,
        statusLabel:
          o.status === 1 ? "ממתין לאישור" : o.status === 2 ? "מאושר" : "נדחה",
      })),
    });

    const load = async () => {
      setLoading(true);
      try {
        const PAGE_SIZE = 25;

        let p = 1;
        let totalPages = 1;
        let found = null;

        while (!found && p <= totalPages && p <= 100) {
          const { data } = await axios.get(
            `${API_DOMAIN}/offer/getProviderReceivedOffers`,
            {
              params: {
                user_id: currentUser.id,
                status,
                car_id: carId,
                page: p,
                pageSize: PAGE_SIZE,
              },
            }
          );

          if (cancelled) return;

          const meta = data?.meta || {};
          totalPages = Number(meta.totalPages || 1);

          const list = Array.isArray(data?.data) ? data.data : [];
          found = list.find((g) => Number(g?.car?.id) === carId) || null;

          p += 1;
        }

        if (!found?.car) {
          setGroup(null);
          return;
        }

        setGroup(mapGroup(found));
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [currentUser?.id, carId, status]);

  const title = useMemo(
    () => (status === 2 ? "כל ההצעות לרכב (מאושרות/נדחו)" : "כל ההצעות לרכב"),
    [status]
  );

  return (
    <>
      {/* ✅ אותה מעטפת בדיוק כמו בעמוד הראשי כדי שהמובייל ייראה אותו דבר */}
      <div
        className="flex bg-blue_gray-50 p-8 sm:p-4 wrap-recieved-offrers"
        style={{ paddingTop: "1rem" }}
      >
        <div className="w-[100%] items-start gap-4 md:flex-col" style={{ gap: "2%" }}>
          <div className="flex relative flex-1 flex-col gap-8 self-center rounded-[24px] bg-secondary-primary_white p-6 md:self-stretch sm:p-4">
            {/* HEADER – כמו הראשי (רק בלי טאבים) */}
            <header className="flex flex-col items-start gap-3">
              <div className="flex items-center justify-between gap-5 mt-5 self-stretch border-b border-solid border-gray-200 md:flex-col">
                <div className="flex items-center gap-3 w-full">
                  {/* תמונה שמאלה */}
                  <Img src="/images/ad-123.svg" alt="Car" className="mr-auto hidden sm:block hide-mobile" />

                  {/* כפתור חזרה - במובייל שיהיה נוח */}
                  <Button
                    size="lg"
                    shape="round"
                    className="rounded-[16px] border border-solid border-gray-300 px-4 py-2 font-semibold sm:w-full sm:justify-center"
                    onClick={() => navigate(-1)}
                  >
                    חזרה
                  </Button>

                  {/* כותרת */}
<div className="w-full md:w-auto flex justify-center md:justify-start">
  <Heading
    size="heading9xl"
    as="h4"
    className="!font-heebo text-[25px] font-bold lg:text-[21px] sm:text-[18px] text-center md:text-left"
  >
    {title}
  </Heading>
</div>


                  {/* אייקון ימינה */}
                  <Img
                    src="/images/img_user_red_a700_03_1.svg"
                    alt="User"
                    className="h-[36px] hidden sm:block hide-mobile"
                  />
                </div>
              </div>
            </header>

            {/* BODY */}
            <div className="flex flex-col gap-6">
              {loading ? (
                <div>…טוען…</div>
              ) : !group ? (
                <div>לא נמצאו הצעות לרכב זה.</div>
              ) : status === 2 ? (
                <ApprovedOffersProvider
                  car={group.car}
                  rows={group.offers}
                  updateShowApprovedOfferPopup={UpdateShowApprovedOfferPopup}
                  setSelectedCar={setSelectedCar}
                  setSelectedOffer={setSelectedOffer}
                />
              ) : (
                <AllOffersProviderLinesRowSeven
                  car={group.car}
                  rows={group.offers}
                  updateShowApprovedOfferPopup={UpdateShowApprovedOfferPopup}
                  setSelectedCar={setSelectedCar}
                  setSelectedOffer={setSelectedOffer}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ✅ POPUP לאחר אישור */}
      {showApprovedOfferPopuop && (
        <ApproveOfferByProviderPopup onClose={handlePopupClose} car={selectedCar} offer={selectedOffer} />
      )}
    </>
  );
}
